module.exports = __webpack_public_path__ + "media/images/client_logos/logo_enedis_200-df45b8a06d23b9063835ce0fc48e48be.png";